module.exports = __webpack_public_path__ + "static/media/Girls-Hostel.3a2b225d.jpg";